import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e77107d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ad-unit-home" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_card = _resolveComponent("game-card")!
  const _component_home_section_tiles = _resolveComponent("home-section-tiles")!
  const _component_news_card = _resolveComponent("news-card")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.trendingGame != undefined)
      ? (_openBlock(), _createBlock(_component_game_card, {
          key: 0,
          class: "game-card max-width spacing-top card-spacing",
          game: _ctx.trendingGame,
          type: "highlighted"
        }, null, 8, ["game"]))
      : _createCommentVNode("", true),
    _createVNode(_component_home_section_tiles),
    (_ctx.trendingNews != undefined)
      ? (_openBlock(), _createBlock(_component_news_card, {
          key: 1,
          class: "news-card max-width card-spacing",
          type: "highlighted",
          news: _ctx.trendingNews
        }, null, 8, ["news"]))
      : _createCommentVNode("", true),
    (_ctx.pageReady)
      ? (_openBlock(), _createBlock(_component_layout_footer, {
          key: 2,
          spot: _ctx.adSpotFooter
        }, null, 8, ["spot"]))
      : _createCommentVNode("", true)
  ]))
}